import n from "countly-sdk-web";
var u = /* @__PURE__ */ ((e) => (e.SESSION = "session", e.INTERACTION = "interaction", e.ACTION = "action", e.START_ACTION = "startAction", e.END_ACTION = "endAction", e))(u || {}), h = /* @__PURE__ */ ((e) => (e.ABSENCE = "absence", e.ADMIN = "admin", e.APP = "app", e.APP_SWITCHER = "appSwitcher", e.AUTH = "auth", e.CALENDAR = "calendar", e.CALENDAR_EVENT = "calendarEvent", e.CHANNEL = "channel", e.CHANNEL_MESSAGE = "channelMessage", e.CHAT = "chat", e.CHAT_MESSAGE = "chatMessage", e.CLASSBOOK = "classbook", e.CLOUD = "cloud", e.COURSE_MEMBER = "courseMember", e.DIGITAL_CLASS = "digitalClass", e.DISCOVERY = "discovery", e.GROUP = "group", e.GROUPS = "groups", e.HOMEWORK = "homework", e.MORE = "more", e.NEWS = "news", e.AI = "ai", e.NOTICE = "notice", e.NOTIFICATION_CENTER = "notificationCenter", e.PUSH = "push", e.STUDENT_STATISTICS = "studentStatistics", e.SURVEY = "survey", e.TABLE = "table", e.TIMETABLE = "timetable", e.TRANSLATE = "translate", e.TUTORIAL = "tutorial", e.USER_AUTHENTICATION = "userAuthentication", e.USER_SETTINGS = "userSettings", e))(h || {}), g = /* @__PURE__ */ ((e) => (e.USE = "use", e.SESSION = "session", e))(g || {}), d = /* @__PURE__ */ ((e) => (e.FEATURE = "feature", e))(d || {});
async function f(e) {
  const i = ((r) => {
    const a = encodeURIComponent(r), o = new Uint8Array(a.length);
    for (let c = 0; c < a.length; c++)
      o[c] = a.charCodeAt(c);
    return o;
  })(e), s = (r) => Array.from(new Uint8Array(r)).map((a) => a.toString(16).padStart(2, "0")).join("");
  return crypto ? crypto.subtle.digest("SHA-256", i).then((r) => s(r)) : window.msCrypto.subtle.digest("SHA-256", i).then((r) => s(r));
}
function p(e, t) {
  const s = ["app_key", "url"].filter((r) => !e[r]);
  s.length > 0 && console.error(`[${t}] Missing required config: ${s.join(", ")}`);
  try {
    new URL(e.url);
  } catch {
    console.error(`[${t}] Invalid server URL format`);
  }
}
function _(e, t, i) {
  if (!e || typeof e != "string")
    return !1;
  const s = e.split("-");
  if (s.length < 2) return !1;
  const r = s[s.length - 1];
  if (!Object.values(t).includes(r))
    return !1;
  const o = e.substring(0, e.lastIndexOf("-"));
  return Object.values(i).some((A) => o === A);
}
const l = ["sessions", "events", "views", "users", "feedback", "remote-config", "content"];
class y {
  constructor(t, i = () => ({}), s = () => window?.location?.pathname) {
    this.getSegmentation = i, this.getRouteName = s, this.active = !1, this.pageChangeTimeout = null, this.initPromise = null, p(t, "SduiAnalytics"), this.config = t;
  }
  async init(t) {
    if (this.initPromise) return this.initPromise;
    if (!this.active)
      return this.initPromise = this.initialize(t), this.initPromise;
  }
  async initialize(t) {
    try {
      const i = t ? await f(t.id) : void 0;
      this.setupCountlyConfig(i), this.startTracking(), this.enableTrackingFeatures(), this.setProfile(t);
    } catch (i) {
      console.error("[SduiAnalytics] Failed to initialize Countly", i);
    } finally {
      this.initPromise = null;
    }
  }
  setupCountlyConfig(t) {
    t && (n.getViewUrl = this.getRouteName.bind(this), n.getViewName = this.getRouteName.bind(this), n.init({
      ...this.config,
      require_consent: !0,
      clear_stored_id: !0,
      enable_orientation_tracking: !1,
      namespace: "user",
      device_id: t,
      remote_config: !0
    }));
  }
  async setProfile(t) {
    t && n.user_details({
      organization: t.organization,
      custom: t.custom
    });
  }
  startTracking() {
    n.add_consent(l), this.active = !0;
  }
  enableTrackingFeatures() {
    n.track_sessions(), n.track_pageview(), n.content.enterContentZone();
  }
  stopTracking() {
    this.active && (n.remove_consent(l), this.active = !1);
  }
  handleRouteNavigation(t, i) {
    if (!this.active) return;
    const s = this.getRouteName(t), r = this.getRouteName(i);
    t.path === i.path && s === r || (this.pageChangeTimeout && clearTimeout(this.pageChangeTimeout), this.pageChangeTimeout = setTimeout(() => {
      console.info(`%c ROUTER => Route: ${s}!`, "background: #e23467; color: #fff"), this.trackNewPageView();
    }, 0));
  }
  trackNewPageView() {
    n.track_pageview(void 0, void 0, this.getSegmentation?.());
  }
  addEvent(t, i) {
    if (!this.active) {
      console.warn("[SduiAnalytics] is not active");
      return;
    }
    if (!_(t, u, h)) {
      console.error(`[SduiAnalytics] Event ${t} not valid!`);
      return;
    }
    const s = {
      key: t,
      segmentation: { ...this.getSegmentation?.(), ...this.actionParamsToKebabCase(i) }
    };
    n.q.push([this.config.app_key, "add_event", s]);
  }
  actionParamsToKebabCase(t) {
    return t.action ? {
      ...t,
      action: t.action.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()
    } : t;
  }
  handleFeedbackWidgets(t, i, s, r) {
    if (r) {
      console.log(r);
      return;
    }
    const a = s.find((o) => o._id === t);
    if (!a) {
      console.error(`[Countly] No ${t} widget found`);
      return;
    }
    n.q.push([this.config.app_key, "present_feedback_widget", a, i, void 0, void 0]);
  }
  reportFeedback({ widgetId: t, selectorId: i }) {
    this.active && n.q.push([this.config.app_key, "get_available_feedback_widgets", (s, r) => {
      this.handleFeedbackWidgets(t, i, s, r);
    }]);
  }
  fetchConfig(t) {
    if (this.active)
      try {
        return n.get_remote_config(t);
      } catch (i) {
        return console.error("[SduiAnalytics] Failed to fetch config", i), null;
      }
  }
  closeSurvey({ widgetId: t }) {
    this.active && n.q.push([this.config.app_key, "add_event", {
      key: "[CLY]_survey",
      segmentation: {
        widget_id: t,
        closed: 1
      }
    }]);
  }
}
const S = ["events", "users", "location"];
class T {
  constructor(t, i = () => ({})) {
    this.getSegmentation = i, this.active = !1, this.initPromise = null, p(t, "GlobalAnalytics"), this.config = t;
  }
  async init(t) {
    if (this.initPromise) return this.initPromise;
    if (!this.active)
      return this.initPromise = this.initialize(t), this.initPromise;
  }
  async initialize(t) {
    try {
      const i = t && await f(t.uuid);
      this.setupCountlyConfig(i), n.q.push([this.config.app_key, "add_consent", S]), this.setProfile(t), this.active = !0;
    } catch (i) {
      console.error("[GlobalAnalytics] Failed to initialize Countly", i);
    } finally {
      this.initPromise = null;
    }
  }
  setupCountlyConfig(t) {
    t && n.q.push([
      "init",
      {
        app_key: this.config.app_key,
        url: this.config.url,
        debug: this.config.debug,
        device_id: t,
        clear_stored_id: !0,
        enable_orientation_tracking: !1,
        namespace: "global",
        require_consent: !0
      }
    ]);
  }
  handleRouteNavigation() {
  }
  async setProfile(t) {
    t && n.q.push([
      this.config.app_key,
      "user_details",
      {
        organization: t.organization,
        custom: t.custom
      }
    ]);
  }
  stopTracking() {
    this.active && (this.active = !1);
  }
  trackNewPageView() {
    n.q.push([
      this.config.app_key,
      "track_pageview",
      void 0,
      void 0,
      this.getSegmentation?.()
    ]);
  }
  addEvent(t, i) {
    if (!this.active) {
      console.warn("[GlobalAnalytics] is not active");
      return;
    }
    if (!_(t, g, d)) {
      console.error(`[GlobalAnalytics] Event ${t} not valid!`);
      return;
    }
    const s = {
      key: t,
      segmentation: { ...this.getSegmentation?.(), ...i }
    };
    n.q.push([this.config.app_key, "add_event", s]);
  }
  reportFeedback({ widgetId: t, selectorId: i }) {
    this.active && console.log("reportFeedback", t, i, this.config.app_key);
  }
}
export {
  T as GlobalTracking,
  y as UserTracking
};
//# sourceMappingURL=index.esm.js.map
